/** Status keys used for overview order-count charts and totals. */
export const ORDER_COUNTS_MAIN_STATUSES = [
  'CREATED',
  'PENDING',
  'IN_PROGRESS',
  'COMPLETED',
  'CANCELLED',
] as const;

/**
 * True when `orderCounts` looks like a real snapshot (not null/undefined and not `{}`).
 * Requires at least one main status key to be present so we do not show all-zero charts for empty maps.
 */
export function hasOrderCountsSnapshot(
  orderCounts: Record<string, number> | null | undefined,
): boolean {
  if (orderCounts == null) return false;
  return ORDER_COUNTS_MAIN_STATUSES.some((s) => orderCounts[s] !== undefined);
}
